import { createTheme } from '@mui/material';

export const appTheme = createTheme({
  palette: {
    primary: {
      main: '#FFA000',
    },
    secondary: {
      main: '#7C4DDF',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
});

export const appThemeDark = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#e666fb',
    },
    secondary: {
      main: '#FFA000',
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
});
